"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var StyledInputTime = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    \n    label {\n        font-weight: bold;\n        margin-bottom: 10px;\n    }\n\n    input {\n\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    \n    label {\n        font-weight: bold;\n        margin-bottom: 10px;\n    }\n\n    input {\n\n    }\n"])));
exports.default = StyledInputTime;
var templateObject_1;
